import React from "react";

/** Common 404 error page used by react-router-dom for no matching routes */
export default function Error404() {
    return (
        <main>
            <h1>404</h1>
            <p>There&apos; nothing at this route. Sorry!</p>
        </main>
    );
}
